export const FETCH_SHORT_FAVOURITE = 'FETCH_SHORT_FAVOURITE'
export const RESET_SHORT_FAVOURITE = 'RESET_SHORT_FAVOURITE'
